import { AfterViewInit, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { AssistantService } from '../../../common/assistant.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent implements AfterViewInit {

  @Input({ required: true }) control!: FormControl;
  @Input({ required: true }) controlName!: string;
  @Input() assistantServiceEnabled: boolean;
  @Input() saveLastFocusedEnabled: boolean;
  @Output() clickHandler = new EventEmitter<string>();
  @ViewChildren(NgbPopover) private assistantPopoverList: QueryList<NgbPopover>;

  ngAfterViewInit(): void {
    this.assistantService.initializeAssistant(this.assistantPopoverList);
  }

  constructor(private assistantService: AssistantService) {}

  onCheckboxClicked() {
    this.clickHandler.emit(this.controlName);
  }

  disableAssistant() {
    this.assistantService.disable();
  }
}
